import React from "react";
import HeroSection from "../../components/User/Home/HeroSection";
import CoachingPrograms from "../../components/User/Home/CoachingPrograms";
import AllEventsSection from "../../components/User/Home/AllEventsSection";
import WhoWeAreSection from "../../components/User/Home/WhoWeAreSection";
import FieldRentalsSection from "../../components/User/Home/FieldRentalsSection";
import AdditionalInformation from "../../components/User/Home/AdditionalInformation";
import HomeFaqs from "../../components/User/Home/HomeFaqs";
import NewHeroSection from "../../components/User/Home/NewHeroSection";

const Home = () => (
  <React.Fragment>
    <NewHeroSection />
    <CoachingPrograms />
    <AllEventsSection />
    <FieldRentalsSection />
    <WhoWeAreSection />
    <AdditionalInformation />
    <HomeFaqs />
  </React.Fragment>
);

export default Home;
